import { openBlock, createElementBlock, mergeProps } from 'vue';

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", mergeProps(_ctx.$attrs, { style: _ctx.computedStyle }), null, 16);
}

export { render };
//# sourceMappingURL=visual-hidden.vue_vue_type_template_id_4cbd1102_lang.mjs.map
